import type * as React from 'react';
import facilityWorkflowsFetched, {
	type FacilityWorkflowPayload,
	type FacilityWorkflowsFetchedAction,
} from '@Application/Facilities/Workflows/Actions/facilityWorkflowsFetched';
import facilityWorkflowsFetchFailed, {
	type FacilityWorkflowsFetchFailedAction,
} from '@Application/Facilities/Workflows/Actions/facilityWorkflowsFetchFailed';
import type FetchFacilityWorkflows from '@Application/Facilities/Workflows/Queries/FetchFacilityWorkflows';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilityWorkflowsFetchedAction | FacilityWorkflowsFetchFailedAction;

const buildWorkflowsUrl = (query: FetchFacilityWorkflows): string => {
	const facilityUrl = `${parameters.api.host}/api/facilities/${query.facilityId}`;

	return query.subject.isBeneficiary
		? `${facilityUrl}/workflows`
		: `${facilityUrl}/subjects/${query.subject.subjectId}/workflows`;
};

export default (query: FetchFacilityWorkflows) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<FacilityWorkflowPayload[]>(buildWorkflowsUrl(query));

			const action = facilityWorkflowsFetched(payload, query.facilityId, query.subject.typeKey);
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilityWorkflowsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
